import {defineRouting} from 'next-intl/routing';

export const routing = defineRouting({
  locales: ['pt', 'en'],
  defaultLocale: 'pt',
  localeDetection: true,
  localePrefix: {
    mode: 'always',
  },
  pathnames: {
    '/': '/',
  },
  localeCookie: {
    maxAge: 60 * 60 * 24 * 365
  }
});
